import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.import}drafts`;

interface DeleteDraftCommandPayload {
  draftId: string;
}

type DeleteDraftCommand = (
  payload: DeleteDraftCommandPayload,
) => Promise<BaseBackResponse | BackResponseFailure>;

const deleteDraftCommand: DeleteDraftCommand = async ({ draftId }) => {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.DELETE,
      json: {
        draftId,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default deleteDraftCommand;
